import "../sellscreendialogs.scss";
import { type FC, useState } from "react";
import { useShopfrontDispatch } from "../../../../_Bootstrap/hooks";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { addPaymentToSale, type GiftCardPayment } from "../../../../Actions/SellScreen/SellScreenPaymentActions";
import Button from "../../../../Common/Buttons/Button";
import NoTranslate from "../../../../Common/NoTranslate";
import PopupManager from "../../../../Common/Popups/PopupManager";
import { getEnterpriseAuthToken } from "../../../../Data/_Bases/BaseEnterpriseRepository";
import { type SalePayment } from "../../../../Reducers/SellScreen/SellScreenSaleReducerTypes";
import { currency } from "../../../../Utilities/Generic/Numbers";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { getPolicy } from "../../../../Utilities/Platform/Policies/Policies";
import { getMainHost, getVendorSubdomain } from "../../../../Utilities/Platform/Request";

export const RevertPayment: FC<{
    index: number;
    method: string;
    amount: number;
    cashout: number;
    rounding: number;
    giftCard?: GiftCardPayment;
    name: string;
    payment: SalePayment;
}> = ({
    index,
    method,
    amount,
    cashout,
    giftCard,
    name,
    payment,
    rounding,
}) => {
    const [ paying, setPaying ] = useState(false);
    const dispatch = useShopfrontDispatch();

    if(paying) {
        return (
            <div>
                <p>Processing payment...</p>
                <div>
                    <FontAwesomeLight icon="spinner-third" spin />
                </div>
            </div>
        );
    }

    let cashoutRender = null;

    if(cashout) {
        cashoutRender = (
            <>
                <br />
                with cash out of
                <b className="cashout pre-space">
                    <NoTranslate>
                        {currency(cashout)}
                    </NoTranslate>
                </b>
            </>
        );
    }

    return (
        <div className="revert-payment">
            <p>
                Revert <b>{name}</b> payment of
                <b className="pre-space">
                    <NoTranslate>
                        {currency(amount)}
                    </NoTranslate>
                </b>
                {cashoutRender}?
            </p>
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    No
                </Button>
                <Button
                    type="button"
                    classes={[ "button-danger" ]}
                    onClick={async () => {
                        if(typeof giftCard !== "undefined" && giftCard.source !== "internal") {
                            // Process the reversal
                            setPaying(true);
                            let source;
                            const sources = getPolicy("gift_card_sources", []);

                            for(let i = 0, l = sources.length; i < l; i++) {
                                if(sources[i].connection === giftCard.source) {
                                    source = sources[i].address;
                                    break;
                                }
                            }

                            if(!source) {
                                PopupManager.error("Gift card source is no longer available, please try again");

                                return;
                            }

                            const response = await fetch(`${source}/${giftCard.id}/refund`, {
                                method : "PUT",
                                headers: {
                                    "x-shopfront-token" : await getEnterpriseAuthToken(giftCard.source),
                                    "x-shopfront-vendor": getVendorSubdomain(),
                                    "x-shopfront-host"  : getMainHost(),
                                    "accept"            : "application/json",
                                },
                                body: JSON.stringify({
                                    amount,
                                }),
                            });

                            const body = await response.json();

                            if(response.status !== 200) {
                                console.error("Unable to redeem a gift card", body);
                                let message;

                                if(body.error && body.message) {
                                    message = body.message;
                                } else {
                                    message = "Unknown Error";
                                }

                                PopupManager.error(`Unable to reverse a gift card, response from Enterprise: ${message}`);

                                setPaying(false);

                                return;
                            }
                        }

                        dispatch(hideDialog());
                        dispatch(addPaymentToSale(method, amount * -1, {
                            cashout  : cashout * -1,
                            refund   : true,
                            reverting: true,
                            rounding : rounding * -1,
                            giftcard : typeof giftCard !== "undefined" ? giftCard : "auto",
                            related  : {
                                ...payment,
                                index: index,
                            },
                        }));
                    }}
                >
                    Yes
                </Button>
            </div>
        </div>
    );
};
